import i18nClient from '../i18n-client';

let i18nInstance;
if(!module.hot) {
    try {
        i18nInstance = i18nClient;
        i18nInstance.changeLanguage(window.__i18n__.locale);
        i18nInstance.addResourceBundle(window.__i18n__.locale, 'common', window.__i18n__.resources, true);
    } catch(e) {
        console.warn('i18n error', e);
        i18nInstance = i18nClient;
    }    
} else {
    i18nInstance = i18nClient;
}

export default i18nInstance;